module.exports = __webpack_public_path__ + "img/cardNoShow.28169f7a.png";